export const MAIN_ROW_FILTER_TYPES = [
  { label: "Status", value: "STATUS" },
  { label: "Due Date", value: "DUE_DATE" },
  { label: "Completed Date", value: "COMPLETED_DATE" },
  { label: "Created Date", value: "CREATED_DATE" },
  { label: "Assignee", value: "ASSIGNEE" },
  { label: "Progress", value: "PROGRESS" },
  { label: "Priority", value: "PRIORITY" },
  { label: "Subactions (Linked)", value: "LINKED_ACTIONS" },
  { label: "Privacy", value: "PRIVACY_STATUS" },
  { label: "Created By", value: "CREATED_BY" },
];

export const TASK_STATUS_TYPES = [
  { label: "Overdue", value: "OVERDUE" },
  { label: "Not due", value: "NOT_DUE" },
  { label: "Ongoing", value: "ONGOING" },
  { label: "Complete", value: "COMPLETE" },

];

export const DATE_TYPE_OPTIONS = [
  { label: "Date", value: "DATE" },
  { label: "Date Range", value: "DATE_RANGE" },
];

export const TASK_PROGRESS_TYPES = [
  { label: "In progress", value: "IN_PROGRESS" },
  { label: "Completed", value: "COMPLETED" },
  { label: "Not Started", value: "NOT_STARTED" },
];

export const TASK_PRIVACY_TYPES = [
  { label: "Public", value: "PUBLIC" },
  { label: "Private", value: "PRIVATE" },
  { label: "Assigned to Me", value: "ASSIGNED_ME" },
];

export const METRICS_FILTER_TYPES = [
  { label: "Name", value: "NAME" },
  { label: "Created On", value: "CREATED_ON" },
  { label: "Created By", value: "CREATED_BY" },
  { label: "Address", value: "LOCATION" },
];
